import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';

@Component({
    selector: 'app-error',
    templateUrl: './error-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogModule]
})
export class ErrorDialogComponent {
  data = inject(MAT_DIALOG_DATA, { optional: true });
  private dialog = inject(MatDialog);

  error: any;

  public showErrorMessage(error: any, status?: number | string): Promise<any> {
    console.log(error);
    this.dialog.open(ErrorDialogComponent, {
      minWidth: 300,
      data: {
        errorMessage: error.message || error.error || error,
      },
    });

    return Promise.resolve(error.message || error);
  }
}
